import React, { Fragment, useEffect, useRef, useState } from "react";
import { HeaderOverlay, MenuNavbar, Seo } from "../components";
import { useTranslation } from "react-i18next";
// import useGetPage from "../hooks/useGetPage";
import Footer from "../components/Footer/Footer";
import HeaderBannerOne from "../components/HeaderCore/HeaderBannerOne";
import TimeLineItem from "../components/TimeLines/TimeLineItem";
import ViewPDF from "../components/ViewPDF/ViewPDF";
import useStrAPI from "../hooks/useStrAPI";
import { baseUrl } from "../services/Environment";
import { Table } from "react-bootstrap";

function Governance() {
  const [lang, setLang] = useState();
  const { t, i18n } = useTranslation();
  const { GetDatas, loading, getStrAPI } = useStrAPI();

  function scrollToElement(id) {
    let offset = 70; // ระยะ offset ที่ต้องการ
    const element = document.getElementById(id);
    const offsetTop = element.offsetTop - offset; // คำนวณระยะ offset ที่ต้องการเลื่อน

    window.scrollTo({
      top: offsetTop,
      behavior: "smooth", // เลื่อนโดยการ animate ให้เรียบร้อย
    });
  }

  function scrollToSubElement(id) {
    let offset = 120; // ระยะ offset ที่ต้องการ
    const element = document.getElementById(id);

    const offsetTop = element.offsetTop - offset; // คำนวณระยะ offset ที่ต้องการเลื่อน

    window.scrollTo({
      top: offsetTop,
      behavior: "smooth", // เลื่อนโดยการ animate ให้เรียบร้อย
    });
  }

  useEffect(() => {
    // console.log(localStorage.getItem("itemsHref"));
    if (localStorage.getItem("ncl_lang")) {
      setLang(localStorage.getItem("ncl_lang"));
      i18n.changeLanguage(lang);
    } else {
      setLang("th");
    }

    if (lang !== undefined) {
      getStrAPI("file-managements", lang);
    }
  }, [lang]);

  let itemsHref = window.location.hash;
  if (
    itemsHref !== "" &&
    itemsHref !== "#" &&
    itemsHref !== "itemsHref" &&
    itemsHref !== undefined &&
    itemsHref !== null
  ) {
    const element = document.querySelector(itemsHref);
    if (element) {
      const offset = 80;
      const offsetTop = element.offsetTop - offset;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth", // เลื่อนโดยการ animate ให้เรียบร้อย
      });
    }

    // console.log("itemsHref", itemsHref);
  }

  const handleLang = (event, attrLang) => {
    window.location.hash = "";
    let changeText = attrLang === "th" ? "en" : "th";
    localStorage.setItem("ncl_lang", changeText);
    setLang(localStorage.getItem("ncl_lang"));
    i18n.changeLanguage(lang);
  };

  console.log(GetDatas?.data, "GetDatas?.data.");

  // console.log(baseUrl+GetDatas?.data[0].attributes.file.data.attributes.url)
  return (
    <Fragment className="overflowX">
      <Seo
        title="Home"
        description="A description of the page"
        name="Company name"
        type="articlec"
        keywords="HTML, CSS, JavaScript"
      />

      <MenuNavbar>
        <div className="align-items-center icon-nav-custom">
          <img
            src="images/icon/icon-12.png"
            alt={"NCL Language " + lang}
            // height="30"
            className="narbar_link img-icon-nav"
            data-lang={lang}
            onClick={(event) => {
              console.log("aaaaaaaaaa", event.target.attributes);
              handleLang(
                event.target,
                event.target.attributes.getNamedItem("data-lang").value
              );
            }}
          />
          <span
            style={{ textTransform: "uppercase" }}
            className="pt-1 narbar_font"
            data-lang={lang}
            onClick={(event) =>
              handleLang(
                event.target,
                event.target.attributes.getNamedItem("data-lang").value
              )
            }
          >
            {lang}
          </span>
        </div>
      </MenuNavbar>

      {/* Header */}

      <HeaderBannerOne
        img={"/images/governance/Headerการกำกับดูแลกิจการที่ดี-25.jpg"}
        // imgMobile={
        //   "/images/banner/นักลงทุนสัมพันธ์(ข้อมูลบริษัท)-Mobile-01.jpg"
        // }
        imgMobile={"/images/banner/Headerการกำกับดูแลกิจการที่ดี-Mobile-01.jpg"}
        id={"BgBanner"}
        title={lang === "th" ? "การกำกับดูแล" : "Good Governance"}
        colorH1={"text-white"}
        colorP={"text-white"}
      />

      <div className=" d-flex d-xl-none flex-column  text-center ">
        <a
          href="#list"
          className="bg-blue d-flex justify-content-center gap-2 text-white py-2"
          data-bs-toggle="collapse"
        >
          เมนูเพิ่มเติม
          <div className="dropdown-toggle"></div>
        </a>
        <ul
          id="list"
          className="collapse px-0 pt-3 bg-Lgray"
          data-bs-parent="#list"
        >
          <li className="pointer " onClick={() => scrollToElement("criteria")}>
            {lang === "th"
              ? `นิยามกรรมการอิสระ`
              : `Criteria for Independent Directors`}
          </li>
          <hr />
          <li className="pointer" onClick={() => scrollToElement("article")}>
            {lang === "th" ? `ข้อบังคับบริษัท` : `Article of Association`}
          </li>
          <hr />

          <li className="pointer" onClick={() => scrollToElement("policy")}>
            {lang === "th"
              ? `นโยบายการกำกับดูแลกิจการ`
              : `Corporate Governance Policy`}
          </li>

          <li
            className=" subPointer m-0 text-secondary"
            onClick={() => scrollToSubElement("report")}
            style={{ listStyle: "none" }}
          >
            {lang === "th"
              ? ` รายงานการถือครองหลักทรัพย์ของกรรมการและผู้บริหาร ของบริษัทฯ ปี
              2568 และ 2567`
              : `Report on Securities Holdings of Directors and Executives of the Company for the Fiscal Years 2025 and 2024`}
          </li>
          <hr />

          {/* <li
            onClick={() => scrollToElement("Report on Securities Holdings")}
            className="pointer"
          >
            {lang === "th"
              ? `นโยบายและแนวทางปฏิบัติในการต่อต้านการทุจริตคอร์รัปชัน`
              : `Guidelines for Prevention of Involvement in Corruption`}
          </li>
          <li
            className="subPointer m-0  text-secondary"
            onClick={() => scrollToSubElement("Report on Securities Holdings")}
            style={{ listStyle: "none" }}
          >
            {lang === "th"
              ? `นโยบายและแนวทางปฏิบัติในการต่อต้านการทุจริตคอร์รัปชัน`
              : `Guidelines for Prevention of Involvement in Corruption`}
          </li> */}
          {/* <li
            className="subPointer m-0 text-secondary"
            onClick={() => scrollToSubElement("receiving")}
            style={{ listStyle: "none" }}
          >
            {lang === "th"
              ? `นโยบายเกี่ยวกับการรับ-การให้ของขวัญและสิ่งตอบแทน`
              : `Policy on Receiving and Giving Gifts and Recompenses`}
          </li> */}

          {/* <li
            className=" subPointer m-0 text-secondary"
            onClick={() => scrollToSubElement("prevention")}
            style={{ listStyle: "none" }}
          >
            {lang === "th"
              ? `นโยบายเกี่ยวกับการป้องกันการทุจริตและการให้สินบน`
              : `Policy on Prevention of Corruption and Bribery`}
          </li> */}
          {/* <li
            className=" subPointer m-0 text-secondary"
            onClick={() => scrollToSubElement("hosting")}
            style={{ listStyle: "none" }}
          >
            {lang === "th"
              ? `นโยบายเกี่ยวกับการเลี้ยงรับรอง`
              : `Policy on Hosting and Entertainment`}
          </li>
          <li
            className=" subPointer m-0 text-secondary"
            onClick={() => scrollToSubElement("charitable")}
            style={{ listStyle: "none" }}
          >
            {lang === "th"
              ? `นโยบายเกี่ยวกับการบริจาคเพื่อการกุศลและการให้เงินสนับสนุนแก่หน่วยงานภายนอก`
              : `Policy on Charitable Donations and Funding to External Entities`}
          </li>
          <li
            className=" subPointer m-0 text-secondary"
            onClick={() => scrollToSubElement("penalty")}
            style={{ listStyle: "none" }}
          >
            {lang === "th" ? `บทลงโทษ` : `Penalty`}
          </li>
          <hr /> */}

          {/* <li
            className="pointer"
            onClick={() => scrollToElement("Report on Securities Holdings")}
          >
            {lang === "th"
              ? `ปัจจัยความเสี่ยงต่อการดำเนินธุรกิจของบริษัท`
              : `Risk Factors`}
          </li> */}

          {/* <hr /> */}

          <li
            className="pointer mb-3"
            onClick={() => scrollToElement("charter")}
          >
            {lang === "th" ? `กฎบัตรกรรมการ` : `Board Charter`}
          </li>
          <hr />
          <li
            className="pointer  mb-3"
            onClick={() => scrollToElement("complaints")}
          >
            {lang === "th" ? `ช่องทางร้องเรียน` : `Channel for complaints`}
          </li>
        </ul>
      </div>

      <div className=" container ">
        <div className="row d-flex  align-items-start ">
          <div className="col-xl-7 col-sm-12 ">
            {/*---------- นืยามกรรมการอิสระ ---------------*/}
            <section id="criteria" className="pt-5 pb-0">
              <h1
                // href="#ww"
                className=" fw-bold mt-4"
              >
                {lang === "th"
                  ? `นิยามกรรมการอิสระ`
                  : `Criteria for Independent Directors`}{" "}
              </h1>

              <ol className=" d-flex flex-column gap-">
                <li>
                  {lang === "th"
                    ? `ถือหุ้นไม่เกินร้อยละหนึ่งของจำนวนหุ้นที่มีสิทธิออกเสียงทั้งหมดของบริษัทฯ บริษัทใหญ่ บริษัทย่อย บริษัทร่วม ผู้ถือหุ้นรายใหญ่ หรือผู้มีอำนาจควบคุมของบริษัทฯ ทั้งนี้ ให้นับรวมการถือหุ้นของผู้ที่เกี่ยวข้องของกรรมการอิสระรายนั้น ๆ ด้วย
                    `
                    : `Shareholding: Must hold no more than 1% of the total voting
                  shares of the company, its parent company, subsidiary,
                  associate, major shareholder, or controlling entity. This
                  includes shares held by related persons of the independent
                  director. `}
                </li>
                <li>
                  {lang === "th"
                    ? ` ไม่เป็นหรือเคยเป็นกรรมการที่มีส่วนร่วมบริหารงาน ลูกจ้าง พนักงาน ที่ปรึกษาที่ได้เงินเดือนประจำ หรือผู้มีอำนาจควบคุมของบริษัทฯ บริษัทใหญ่ บริษัทย่อย บริษัทร่วม บริษัทย่อยลำดับเดียวกัน ผู้ถือหุ้นรายใหญ่ หรือของผู้มีอำนาจควบคุมของบริษัทฯ  เว้นแต่จะได้พ้นจากการมีลักษณะดังกล่าวมาแล้วไม่น้อยกว่าสองปีก่อนวันที่ได้รับการแต่งตั้งเป็นกรรมการอิสระ ทั้งนี้ ลักษณะต้องห้ามดังกล่าวไม่รวมถึงกรณีที่กรรมการอิสระเคยเป็นข้าราชการ หรือที่ปรึกษา ของส่วนราชการซึ่งเป็นผู้ถือหุ้นรายใหญ่ หรือผู้มีอำนาจควบคุมของบริษัทฯ
                    `
                    : `Management Involvement: Must not be or have ever been a director involved in management, employee, staff member, salaried consultant, or controlling person of the company, its parent company, subsidiary, associate, same-level subsidiary, major shareholder, or controlling entity, unless at least two years have passed since the termination of such relationship. This restriction does not apply to cases where the independent director was a government officer or advisor to a government agency which is a major shareholder or controlling entity of the company.`}{" "}
                </li>{" "}
                <li>
                  {lang === "th"
                    ? ` ไม่เป็นบุคคลที่มีความสัมพันธ์ทางสายโลหิต หรือโดยการจดทะเบียนตามกฎหมาย ในลักษณะที่เป็น บิดา มารดา คู่สมรส พี่น้อง และบุตร รวมทั้งคู่สมรสของบุตร ของกรรมการรายอื่น ผู้บริหาร ผู้ถือหุ้นรายใหญ่ ผู้มีอำนาจควบคุม หรือบุคคลที่จะได้รับการเสนอให้เป็นกรรมการรายอื่น ผู้บริหารหรือผู้มีอำนาจควบคุมของบริษัทฯ หรือบริษัทย่อย
                    `
                    : `Family Relations: Must not be related by blood or legal registration as father, mother, spouse, sibling, or child, including the spouse of a child, to other directors, executives, major shareholders, controlling persons, or persons to be nominated as director, executive, or controlling person of the company or its subsidiaries.
`}
                </li>{" "}
                <li>
                  {lang === "th"
                    ? `ไม่มีหรือเคยมีความสัมพันธ์ทางธุรกิจกับบริษัทฯ บริษัทใหญ่ บริษัทย่อย บริษัทร่วม ผู้ถือหุ้นรายใหญ่ หรือผู้มีอำนาจควบคุมของบริษัทฯ ในลักษณะที่อาจเป็นการขัดขวางการใช้วิจารณญาณอย่างอิสระของตน รวมทั้งไม่เป็นหรือเคยเป็นผู้ถือหุ้นที่มีนัย หรือผู้มีอำนาจควบคุมของผู้ที่มีความสัมพันธ์ทางธุรกิจกับบริษัทฯ บริษัทใหญ่ บริษัทย่อย บริษัทร่วม ผู้ถือหุ้นรายใหญ่ หรือผู้มีอำนาจควบคุมของบริษัทฯ เว้นแต่จะได้พ้นจากการมีลักษณะดังกล่าวมาแล้วไม่น้อยกว่าสองปีก่อนวันที่ได้รับการแต่งตั้งเป็นกรรมการอิสระ ความสัมพันธ์ทางธุรกิจดังกล่าว รวมถึงการทำรายการทางการค้าที่กระทำเป็นปกติเพื่อประกอบกิจการ การเช่าหรือให้เช่าอสังหาริมทรัพย์ รายการเกี่ยวกับสินทรัพย์หรือบริการ หรือการให้หรือรับความช่วยเหลือทางการเงิน ด้วยการรับหรือให้กู้ยืม ค้ำประกัน การให้สินทรัพย์เป็นหลักประกันหนี้สิน รวมถึงพฤติการณ์อื่นทำนองเดียวกัน ซึ่งเป็นผลให้บริษัทฯ หรือคู่สัญญามีภาระหนี้ที่ต้องชำระต่ออีกฝ่ายหนึ่ง ตั้งแต่ร้อยละสามของสินทรัพย์ที่มีตัวตนสุทธิของบริษัทฯ หรือตั้งแต่ยี่สิบล้านบาทขึ้นไป แล้วแต่จำนวนใดจะต่ำกว่า ทั้งนี้ การคำนวณภาระหนี้ดังกล่าวให้เป็นไปตามวิธีการคำนวณมูลค่าของรายการที่เกี่ยวโยงกันตามประกาศคณะกรรมการกำกับตลาดทุนว่าด้วยหลักเกณฑ์ในการทำรายการที่เกี่ยวโยงกัน โดยอนุโลม แต่ในการพิจารณาภาระหนี้ดังกล่าว ให้นับรวมภาระหนี้ที่เกิดขึ้นในระหว่างหนึ่งปีก่อนวันที่มีความสัมพันธ์ทางธุรกิจกับบุคคลเดียวกัน

                    `
                    : `Business Relationships: Must not have or have had any business relationship with the company, its parent company, subsidiary, associate, major shareholder, or controlling entity that may interfere with their independent judgment. This includes not being or having been a significant shareholder or controlling person of any entity having a business relationship with the company, unless at least two years have passed since the termination of such relationship. Business relationships include normal commercial transactions for business operations, real estate rental or leasing transactions, transactions related to assets or services, or providing or receiving financial assistance. These involve obligations that exceed 3% of the company's tangible net assets or 20 million baht, whichever is lower. Calculation of such obligations shall comply with the Capital Market Supervisory Board’s regulations on related party transactions, and include obligations occurring one year before the business relationship.
`}
                </li>{" "}
                <li>
                  {lang === "th"
                    ? `   ไม่เป็นหรือเคยเป็นผู้สอบบัญชีของบริษัทฯ บริษัทใหญ่ บริษัทย่อย บริษัทร่วม ผู้ถือหุ้นรายใหญ่ หรือผู้มีอำนาจควบคุมของบริษัทฯ  และไม่เป็นผู้ถือหุ้นที่มีนัย ผู้มีอำนาจควบคุม หรือหุ้นส่วนของสำนักงานสอบบัญชี  ซึ่งมีผู้สอบบัญชีของบริษัทฯ บริษัทใหญ่ บริษัทย่อย บริษัทร่วม ผู้ถือหุ้นรายใหญ่ หรือผู้มีอำนาจควบคุมของบริษัทฯ สังกัดอยู่ เว้นแต่จะได้พ้นจากการมีลักษณะดังกล่าวมาแล้วไม่น้อยกว่าสองปีก่อนวันที่ได้รับการแต่งตั้งเป็นกรรมการอิสระ
                    `
                    : `Audit Relationship: Must not be or have been an auditor of the company, its parent company, subsidiary, associate, major shareholder, or controlling entity, and must not be a significant shareholder, controlling person, or partner of an audit firm which has the auditor of the company, its parent company, subsidiary, associate, major shareholder, or controlling entity, unless at least two years have passed since the termination of such relationship.
`}
                </li>{" "}
                <li>
                  {lang === "th"
                    ? `ไม่เป็นหรือเคยเป็นผู้ให้บริการทางวิชาชีพใดๆ ซึ่งรวมถึงการให้บริการเป็นที่ปรึกษากฎหมายหรือที่ปรึกษาทางการเงิน ซึ่งได้รับค่าบริการเกินกว่าสองล้านบาทต่อปีจากบริษัทฯ บริษัทใหญ่ บริษัทย่อย บริษัทร่วม ผู้ถือหุ้นรายใหญ่ หรือผู้มีอำนาจควบคุมของบริษัทฯ และไม่เป็นผู้ถือหุ้นที่มีนัย ผู้มีอำนาจควบคุม หรือหุ้นส่วนของผู้ให้บริการทางวิชาชีพนั้นด้วย เว้นแต่จะได้พ้นจากการมีลักษณะดังกล่าวมาแล้วไม่น้อยกว่าสองปีก่อนวันที่ได้รับการแต่งตั้งเป็นกรรมการอิสระ
                    `
                    : `Professional Service Providers: Must not be or have been any professional service provider, including legal or financial consultants who receive service fees exceeding two million baht per year from the company, its parent company, subsidiary, associate, major shareholder, or controlling entity, and must not be a significant shareholder, controlling person, or partner of such professional service provider, unless at least two years have passed since the termination of such relationship.
                    `}
                </li>
                <li>
                  {lang === "th"
                    ? `ไม่เป็นกรรมการที่ได้รับการแต่งตั้งขึ้นเพื่อเป็นตัวแทนของกรรมการของบริษัทฯ
                    ผู้ถือหุ้นรายใหญ่
                    หรือผู้ถือหุ้นซึ่งเป็นผู้ที่เกี่ยวข้องกับผู้ถือหุ้นรายใหญ่`
                    : `Representative Appointment: Must not be a director appointed as a representative of the company's directors, major shareholders, or shareholders who are related to major shareholders.

                    `}
                </li>
                <li>
                  {lang === "th"
                    ? `ไม่ประกอบกิจการที่มีสภาพอย่างเดียวกันและเป็นการแข่งขันที่มีนัยกับกิจการของบริษัทฯ หรือบริษัทย่อย หรือไม่เป็นหุ้นส่วนที่มีนัยในห้างหุ้นส่วน หรือเป็นกรรมการที่มีส่วนร่วมบริหารงาน ลูกจ้าง พนักงาน ที่ปรึกษาที่รับเงินเดือนประจำ หรือถือหุ้นเกินร้อยละหนึ่งของจำนวนหุ้นที่มีสิทธิออกเสียงทั้งหมดของบริษัทอื่น ซึ่งประกอบกิจการที่มีสภาพอย่างเดียวกันและเป็นการแข่งขันที่มีนัยกับกิจการของบริษัทฯ หรือบริษัทย่อย`
                    : `Business Competitors: Must not operate any business that is of the same nature and in significant competition with the company or its subsidiaries, and must not be a significant partner in a partnership or an executive director, employee, staff member, salaried consultant, or holding more than 1% of the total voting shares of another company operating a business that is of the same nature and in significant competition with the company or its subsidiaries.`}
                </li>
                <li>
                  {lang === "th"
                    ? `  ไม่มีลักษณะอื่นใดที่ทำให้ไม่สามารถให้ความเห็นอย่างเป็นอิสระเกี่ยวกับการดำเนินงานของบริษัทฯ`
                    : `Independence: Must not have any characteristics that prevent the expression of independent opinions regarding the company’s operations.
`}
                </li>
              </ol>
            </section>
            {/*---------- ข้อบังคับบริษัท  ---------------*/}
            <section id="article" className="pt-5">
              {" "}
              <h1 className="mb-3 fw-bold">
                {lang === "th"
                  ? `ข้อบังคับบริษัท`
                  : `Article of Association
`}
              </h1>
              {GetDatas?.data
                ?.filter(
                  (item) => item.attributes?.type === "Article of Association"
                )
                ?.sort((a, b) => a.attributes.number - b.attributes.number)
                ?.map((item) => (
                  <ViewPDF
                    title={item.attributes.file_name}
                    href={baseUrl + item.attributes.file.data.attributes.url}
                  />
                ))}
            </section>
            {/*---------- นโยบายการกำกับดูแลกิจการ  ---------------*/}
            <section id="policy" className="pt-5 pb-0">
              <h1 className="fw-bold">
                {lang === "th"
                  ? `นโยบายการกำกับดูแลกิจการ`
                  : `Corporate Governance Policy
`}
              </h1>
              <p style={{ textIndent: "30px" }}>
                <span className="fw-bold">
                  {" "}
                  {lang === "th"
                    ? `นโยบายการกำกับดูแลกิจการ`
                    : `Corporate Governance Policy
`}
                </span>
                {lang === "th"
                  ? `  คณะกรรมการบริษัทได้ตระหนักถึงความสำคัญของการกำกับดูแลกิจการที่ดี
                เนื่องจากเห็นว่ามีความสำคัญและจำเป็นต่อการดำเนินธุรกิจที่ทำให้บริษัท
                มีระบบการบริหารงานที่มีประสิทธิภาพ
                และเป็นส่วนสำคัญในการส่งเสริมกิจการของบริษัท
                ให้มีการขยายตัวอย่างต่อเนื่องและมั่นคงต่อไป
                ซึ่งจะก่อให้เกิดความเชื่อมั่นแก่ผู้ถือหุ้น
                ผู้ลงทุนและผู้ที่เกี่ยวข้องอีกทั้งก่อให้เกิดประโยชน์สูงสุดต่อบริษัทในระยะยาว
                บริษัทจึงได้กำหนดนโยบายการกำกับดูแลกิจการที่ดี (Good Corporate
                Governance) ของบริษัทซึ่งเป็นไปตามหลักการกำกับดูแลกิจการที่ดี
                สำหรับบริษัทจดทะเบียนตลาดหลักทรัพย์แห่งประเทศไทย
                โดยมีวัตถุประสงค์เพื่อใช้ในการกำกับดูแลกิจการของบริษัท
                โดยสามารถแบ่งได้เป็น 5 หมวดดังนี้`
                  : `The Board of Directors realizes the importance of the good corporate governance because we strongly believes that good corporate governance can help the company achieve our corporate commitment in becoming a leading efficient organization equipped with good corporate governance and management excellence. In addition, good corporate governance is also a critical success factor to the company’s continuous business growth and stability which shall impact the confidence of shareholders, investors and all relevant parties as well as long-term business value of the company.  The Board of Directors has established the Good Corporate Governance policy for the Company based on the 5 principles for good corporate governance issued by the Stock Exchange of Thailand as follows:-
                `}
              </p>
              <ol className="d-flex flex-column gap-1">
                <li>
                  {" "}
                  {lang === "th"
                    ? `สิทธิของผู้ถือหุ้น`
                    : `The Rights of Shareholders
`}
                </li>
                <li>
                  {lang === "th"
                    ? `การปฏิบัติต่อผู้ถือหุ้นอย่างเท่าเทียมกัน`
                    : `The Equitable Treatment of Shareholders
`}
                </li>
                <li>
                  {" "}
                  {lang === "th"
                    ? `บทบาทของผู้มีส่วนได้เสีย`
                    : ` Role of Stakeholders`}
                </li>
                <li>
                  {" "}
                  {lang === "th"
                    ? `การเปิดเผยข้อมูลและความโปร่งใส`
                    : `Disclosure of Information and Transparency
`}
                </li>
                <li>
                  {lang === "th"
                    ? `ความรับผิดชอบของคณะกรรมการ`
                    : `Responsibility of the Board
`}
                </li>
              </ol>
            </section>

            {/*------- รายงานการถือครองหลักทรัพย์ของกรรมการและผู้บริหาร ของบริษัทฯ ปี 2568 และ 2567 ------*/}
            <section id="report" className="pt-5">
              <h1 className="fw-bold">
                {lang === "th"
                  ? `รายงานการถือครองหลักทรัพย์ของกรรมการและผู้บริหาร ของบริษัทฯ ปี 2568 และ 2567`
                  : `Report on Securities Holdings of Directors and Executives of the Company for the Fiscal Years 2025 and 2024`}
                <p className="text-secondary">
                  {lang === "th"
                    ? `(ข้อมูล ณ วันที่ 13 มีนาคม 2568
                  รวมการถือครองหลักทรัพย์ของคู่สมรสและบุตรที่ยังไม่บรรลุนิติภาวะ)`
                    : `(as of March 13, 2025, including securities holdings of spouses and underage children)`}
                </p>
              </h1>
              <img
                className="border w-100 display-2  text-center text-white my-2"
                id="BgBanner"
                src={
                  lang === "th"
                    ? "/images/governance/TH-รายงานการถือครองหลักทรัพย์-68.png?v=20250617"
                    : "/images/governance/Eng-รายงานการถือครองหลักทรัพย์-68.png?v=20250617"
                }
              ></img>
              {/* <div className="">
                <ViewPDF
                  title={
                    lang === "th"
                      ? "นโยบายการเข้าทำรายการระหว่างกัน"
                      : "Interoperability policy"
                  }
                  href={
                    baseUrl +
                    GetDatas?.data[1].attributes.file.data.attributes.url
                  }
                />
                <ViewPDF
                  title={
                    lang === "th"
                      ? "นโยบายการกำกับดูแลกิจการที่ดี"
                      : "Good corporate governance policy"
                  }
                  href={
                    baseUrl +
                    GetDatas?.data[2].attributes.file.data.attributes.url
                  }
                />
                <ViewPDF
                  title={
                    lang === "th"
                      ? "นโยบายและแนวทางปฏิบัติการแจ้งเบาะแสการทำผิด (Whistle Blowing) และมาตรการคุ้มครองผู้แจ้งเบาะแส"
                      : "Whistle Blowing Policy and Practice and Whistle blower Protection Measures"
                  }
                  href={
                    baseUrl +
                    GetDatas?.data[3].attributes.file.data.attributes.url
                  }
                />
                <ViewPDF
                  title={
                    lang === "th"
                      ? "นโยบายป้องกันความขัดแย้งทางผลประโยชน์ "
                      : "The Conflict of Interest Policy"
                  }
                  href={
                    baseUrl +
                    GetDatas?.data[4].attributes.file.data.attributes.url
                  }
                />
                <ViewPDF
                  title={
                    lang === "th"
                      ? "นโยบายการใช้ข้อมูลภายใน"
                      : "Insider Information Usage Policy"
                  }
                  href={
                    baseUrl +
                    GetDatas?.data[5].attributes.file.data.attributes.url
                  }
                />

                <ViewPDF
                  title={
                    lang === "th"
                      ? "นโยบายการจ่ายเงินปันผล"
                      : "Dividend Payment Policy"
                  }
                  href={
                    baseUrl +
                    GetDatas?.data[6].attributes.file.data.attributes.url
                  }
                />
                <ViewPDF
                  title={lang === "th" ? "จริยธรรมธุรกิจ" : "Code of Conduct"}
                  href="#"
                />
                <ViewPDF
                  title={
                    lang === "th"
                      ? "นโยบายคุ้มครองข้อมูลส่วนบุคคล"
                      : "Privacy Policy"
                  }
                  href={
                    baseUrl +
                    GetDatas?.data[8].attributes.file.data.attributes.url
                  }
                />
                <ViewPDF
                  title={lang === "th" ? `ปัจจัยความเสี่ยง` : `Risk factors`}
                  href={
                    baseUrl +
                    GetDatas?.data[10].attributes.file.data.attributes.url
                  }
                />
              </div> */}
              <div id="Report on Securities Holdings">
                {GetDatas?.data
                  ?.filter(
                    (item) =>
                      item.attributes?.type === "Report on Securities Holdings"
                  )
                  ?.sort((a, b) => a.attributes.number - b.attributes.number)
                  ?.map((item) => (
                    <ViewPDF
                      id="Report on Securities Holdings"
                      title={item.attributes.file_name}
                      href={baseUrl + item.attributes.file.data.attributes.url}
                    />
                  ))}
              </div>
            </section>

            {/*------- นโยบายและแนวทางปฏิบัติในการต่อต้านการทุจริตคอร์รัปชัน ------*/}
            {/* <section id="curuption" className="pt-5 pb-0">
              <h1 className="fw-bold " style={{ fontSize: "39px" }}>
                {lang === "th"
                  ? "นโยบายและแนวทางปฏิบัติในการต่อต้านการทุจริตคอร์รัปชัน"
                  : "Guidelines for Prevention of Involvement in Corruption"}
              </h1>
              <h4 id="sub_curuption" className="fw-bold">
                {lang === "th"
                  ? "นโยบายและแนวทางปฏิบัติในการต่อต้านการทุจริตคอร์รัปชัน"
                  : "Guidelines for Prevention of Involvement in Corruption"}
              </h4>
              <p style={{ textIndent: "30px" }}>
                {lang === "th"
                  ? ` บริษัทมุ่งมั่นในการดำเนินธุรกิจภายใต้หลักการกำกับดูแลกิจการที่ดี
                โดยความรับผิดชอบต่อสังคมและสิ่งแวดล้อม
                รวมถึงผู้มีส่วนได้เสียทุกฝ่าย
                และได้มีการกำหนดนโยบายการปฏิบัติตามกฎหมายต่อต้านการทุจริตคอร์รัปชัน
                โดยได้กำหนดแนวปฏิบัติเกี่ยวกับการต่อต้านคอร์รัปชันไว้ในคู่มือจริยธรรมทางธุรกิจของบริษัทภายใต้หัวข้อเรื่อง
                “นโยบายเกี่ยวกับการรับ การให้ของขวัญและสิ่งตอบแทน”
                “นโยบายเกี่ยวกับการป้องกันการทุจริตและการให้สินบน”
                “นโยบายเกี่ยวกับการเลี้ยงรับรอง” และ
                “นโยบายเกี่ยวกับการบริจาคเพื่อการกุศลและการให้เงินสนับสนุนแก่หน่วยงานภายนอก”
                โดยสามารถสรุปได้ดังนี้`
                  : "The Company is committed to running its business using good corporate governance principles. The Company takes responsibility for society, the environment, and all stakeholders, and it has formulated policies towards the compliance with anti-corruption laws. Also, it has defined the anti-corruption guidelines in the Company’s Business Code under the headings “Policy on Receiving and Giving Gifts and Recompenses” and “Policy on Prevention of Corruption and Bribery,” which are outlined as follows:"}
              </p>
              <h4 id="receiving" className="fw-bold">
                {lang === "th"
                  ? "    นโยบายเกี่ยวกับการรับ-การให้ของขวัญและสิ่งตอบแทน"
                  : "Policy on Receiving and Giving Gifts and Recompenses"}
              </h4>
              <ul>
                <li>
                  {lang === "th"
                    ? "ผู้บริหารและพนักงานถูกห้ามไม่ให้เรียกผลประโยชน์ใด ๆ จากคู่ค้าและหรือผู้ที่ทำธุรกิจกับบริษัท"
                    : "Executives and employees are prohibited from asking for any benefit from partners or those who do business with the Company."}
                </li>
                <li>
                  {lang === "th"
                    ? "ผู้บริหารและพนักงานถูกห้ามไม่ให้เสนอผลประโยชน์ใด ๆ ต่อบุคคลภายนอก คู่ค้า เพื่อจูงใจให้ปฏิบัติในทางที่มิชอบ"
                    : "Executives and employees are prohibited from offering any benefit to any other third parties or partners in any attempt to persuade them to commit an unlawful action. "}
                </li>
              </ul>
              <h4 id="prevention" className="fw-bold">
                {lang === "th"
                  ? "นโยบายเกี่ยวกับการป้องกันการทุจริตและการให้สินบน"
                  : "Policy on Prevention of Corruption and Bribery"}
              </h4>
              <ul>
                <li>
                  {lang === "th"
                    ? `การรับหรือให้ทรัพย์สินหรือประโยชน์อื่นใดที่อาจสร้างแรงจูงใจในการตัดสินใจอย่างไม่ชอบธรรมควรดำเนินการอย่างถูกต้อง
                  ตรงไปตรงมาและต้องมั่นใจได้ว่าการดำเนินการนั้นจะไม่ทำให้เกิดข้อครหาหรือทำให้บริษัทเสื่อมเสียชื่อเสียงสำหรับสิ่งของที่กรรมการบริษัทได้รับจะเก็บไว้ในสำนักงาน
                  หรือแจกจ่ายให้กับพนักงานในบริษัท`
                    : "Receiving or giving property, or any other benefit that may produce motivation to make an unlawful decision, must be done correctly and straightforwardly, and it must be ensured that the actions will not lead to any criticism of, or a bad reputation to, the Company. What the Directors have received must be kept in the office or distributed to the employees."}
                </li>
                <li>
                  {lang === "th"
                    ? `การจัดซื้อจัดหาต้องดำเนินตามขั้นตอนที่กำหนดไว้ตามระเบียบของบริษัทและมีความเป็นธรรมแก่ผู้ที่มีส่วนเกี่ยวข้อง
                  โดยที่การตัดสินใจต้องคำนึงถึงความสมเหตุสมผลด้านราคา
                  คุณภาพและบริการที่ได้รับ
                  รวมทั้งต้องสามารถตรวจสอบได้อย่างโปร่งใส`
                    : `Procurements must conform to the procedures set forth in the Company’s regulations and they should be fair for stakeholders. The decisions on procurements must take into account the reasonableness of prices, quality and services to receive, and transparent auditability.`}
                </li>
                <li>
                  {lang === "th"
                    ? `ในการทำธุรกรรมกับภาครัฐ
                  บริษัทจะต้องหลีกเลี่ยงการกระทำที่อาจจูงใจให้รัฐหรือพนักงานของรัฐดำเนินการที่ไม่ถูกต้องเหมาะสม
                  อย่างไรก็ดีการสร้างความสัมพันธ์อันดีระหว่างกันหรือการกระทำใด ๆ
                  ในขอบเขตที่เหมาะสมและเป็นธรรมเนียมปฏิบัติตินั้นก็สามารถทำได้
                  เช่น การไปแสดงความยินดีหรือการให้ช่อดอกไม้ในโอกาสต่าง ๆ
                  เป็นต้น`
                    : `As for transactions with the government sector, the Company shall avoid any actions that may persuade the government sector or government officers to take wrongful or improper actions. However, building a good mutual relationship or taking any actions within a proper extent and customary practices are acceptable, e.g. extending congratulations or giving a bouquet for special occasions.
`}
                </li>
              </ul>
              <h4 id="hosting" className="fw-bold">
                {lang === "th"
                  ? `นโยบายเกี่ยวกับการเลี้ยงรับรอง`
                  : `Policy on Hosting and Entertainment`}
              </h4>
              <ul>
                <li>
                  {lang === "th"
                    ? ` บริษัทไม่มีนโยบายที่จะเลี้ยงรับรองกับบุคคลภายนอกที่ทำธุรกิจหรือติดต่องานกับบริษัท
                  ทั้งหน่วยงานของเอกชนและภาครัฐเพื่อหลีกเลี่ยงการปฏิบัติที่เข้าข่ายเป็นการติดสินบน
                  เว้นแต่ การเลี้ยงรับรองนั้นเกิดขึ้นในโอกาสพิเศษต่าง ๆ
                  ตามมารยาทที่ปฏิบัติกันในสังคม หรือเป็นไปตามงบประมาณ
                  หรือเหมาะสมกับโอกาส รวมถึงตามประเพณีนิยมหรือวัฒนธรรม
                  เพื่อรักษาความสัมพันธ์ที่ดีทางธุรกิจ
                  โดยไม่หวังสิ่งใดเป็นการตอบแทน`
                    : `The company does not have a policy to entertain external individuals who conduct business or engage with the company, whether they are from private or government sectors, to avoid actions that could be perceived as bribery. Exceptions are made for hosting events on special occasions in accordance with social etiquette, budget considerations, or appropriate opportunities, including customary traditions or culture, to maintain good business relationships without expecting anything in return.`}
                </li>
                <li>
                  {lang === "th"
                    ? `ผู้บริหารและพนักงานถูกห้ามไม่ให้เลี้ยงรับรองในกรณีที่อาจเกิดความขัดแย้งทางผลประโยชน์
                  เช่น การเลี้ยงรับรองในระหว่างที่การประมูลงานยังดำเนินการอยู่
                  การเลี้ยงรับรองที่ให้เป็นการตอบแทนกันมีการกระทำที่แอบแฝงเพื่อให้ได้มาซึ่งการช่วยเหลือหรือผลประโยชน์`
                    : `Executives and employees are prohibited from hosting events in situations that may lead to conflicts of interest, such as entertaining during an ongoing bidding process or any entertainment provided as a reciprocal favor to gain assistance or benefits.
`}
                </li>
                <li>
                  {lang === "th"
                    ? `ผู้บริหารและพนักงานถูกห้ามไม่ให้เลี้ยงรับรองที่จะขัดต่อนโยบายของคู่ค้าธุรกิจ
                  ภาครัฐ หรือผู้มีส่วนได้เสีย`
                    : `Executives and employees are prohibited from hosting events that contradict the policies of business partners, government agencies, or stakeholders.
`}
                </li>
                <li>
                  {lang === "th"
                    ? `ผู้บริหารและพนักงานถูกห้ามไม่ให้เลี้ยงรับรองโดยมีเจตนาในการแสวงหาผลประโยชน์
                  หรือเพื่อให้ผลต่อการตัดสินใจทางธุรกิจ`
                    : `Executives and employees are prohibited from hosting events with the intent to seek personal benefits or to influence business decisions.
`}
                </li>
                <li>
                  {lang === "th"
                    ? `ผู้บริหารและพนักงานถูกห้ามไม่ให้เลี้ยงรับรองในกรณีที่เป็นการละเมิดนโยบายของบริษัท
                  และกฎเกณฑ์หรือกฎหมายที่เกี่ยวข้อง`
                    : ` Executives and employees are prohibited from hosting events that violate company policies, relevant regulations, or laws.`}
                </li>
                <li>
                  {lang === "th"
                    ? `      การเบิกค่าใช้จ่ายสำหรับการเลี้ยงรับรองให้ถือปฏิบัติตามอำนาจดำเนินการ
                  ในคู่มือการปฏิบัติงานของบริษัท`
                    : `Expenses for hosting and entertainment must be processed according to the operational authority outlined in the company’s operational manual.`}
                </li>
              </ul>
              <h4 id="charitable" className="fw-bold">
                {lang === "th"
                  ? `นโยบายเกี่ยวกับการบริจาคเพื่อการกุศลและการให้เงินสนับสนุนแก่หน่วยงานภายนอก`
                  : `Policy on Charitable Donations and Funding to External Entities
`}
              </h4>
              <ul>
                <li>
                  {lang === "th"
                    ? ` การบริจาคและให้การสนับสนุนแก่หน่วยงานใดนั้นจะต้องพิจารณาถึงความน่าเชื่อถือของหน่วยงาน
                  มีการจัดตั้งอย่างถูกต้องตามกฎหมาย `
                    : `Donations and funding to any organization must consider the credibility and legal establishment of the entity.
`}
                </li>
                <li>
                  {lang === "th"
                    ? ` ต้องดำเนินการในนามบริษัท อย่างโปร่งใส เป็นไปตามนโยบายของบริษัท
                  และถูกต้องตามกฎหมาย`
                    : `All donations and funding must be conducted in the company's name, transparently, in accordance with the company's policies, and compliant with legal requirements.
`}
                </li>
                <li>
                  {lang === "th"
                    ? `    ไม่บริจาคและให้การสนับสนุนไปยังเจ้าหน้าที่หรือบุคคลใดๆ
                  ในนามบุคคล เว้นแต่มีรายละเอียดระบุในหนังสือขอรับการสนับสนุน
                  และมีหลักฐานการรับการสนับสนุนเป็นลายลักษณ์อักษรอย่างชัดเจน`
                    : `Donations and funding must not be directed to any officials or individuals in a personal capacity, unless detailed in a written request for support and supported by clear written evidence of receipt.
`}
                </li>
                <li>
                  {lang === "th"
                    ? ` ควรมีการติดตามหรือตรวจสอบ
                  เพื่อให้มั่นใจว่าการบริจาคหรือการให้เงินสนับสนุนไม่ถูกนำไปใช้เป็นวิธีการหลีกเลี่ยงในการให้สินบน
                  ทั้งนี้การบริจาคหรือการให้เงินสนับสนุนนั้นต้องมีวัตถุประสงค์
                  เพื่อเป็นการประชาสัมพันธ์ ส่งเสริมธุรกิจ
                  และภาพลักษณ์ที่ดีของบริษัท โดยอาจกระทำได้หลายรูปแบบ เช่น
                  การสนับสนุนกิจกรรมทางวัฒนธรรม กิจกรรมเพื่อสังคมและสิ่งแวดล้อม
                  กิจกรรมเพื่อการศึกษาและกีฬา เป็นต้น`
                    : `Monitoring or auditing should be conducted to ensure that donations or funding are not used as a means to circumvent bribery. Donations or funding must aim to publicize, promote the business, and enhance the company’s image. This can be done in various forms such as supporting cultural activities, social and environmental activities, educational, and sports activities.
`}
                </li>
                <li>
                  {lang === "th"
                    ? `การเบิกค่าใช้จ่ายสำหรับการบริจาคให้ถือปฏิบัติตามอำนาจดำเนินการ
                  ในคู่มือการปฏิบัติงานของบริษัท`
                    : `Expenses for donations must be processed according to the operational authority outlined in the company’s operational manual.`}
                </li>
              </ul>

              <h4 id="penalty" className="fw-bold ">
                {lang === "th" ? `บทลงโทษ` : `Penalty`}
              </h4>
              <p style={{ textIndent: "30px" }}>
                {lang === "th"
                  ? ` บริษัทกำหนดให้ ประธานเจ้าหน้าที่บริหาร
                รองประธานเจ้าหน้าที่บริหาร
                หรือผู้บังคับบัญชาแต่ละแผนกเป็นผู้มีอำนาจพิจารณาและดำเนินการลงโทษทางวินัยแก่พนักงานที่กระทำความผิด
                หรือไม่ปฏิบัติตามกฎ ระเบียบ ที่บริษัทกำหนดไว้
                โดยบริษัทกำหนดบทลงโทษทางวินัยไว้เป็นลำดับขั้นตามความผิด
                ตั้งแต่การตักเตือนด้วยวาจาจนถึงการพักงานหรือการเลิกจ้าง`
                  : `The Company has authorized the CEO, Deputy CEO or supervisors in each department to consider and take disciplinary actions on employees who have committed wrong actions or fail to comply with the Company’s regulations. The disciplinary actions are imposed according to the severity of the offense, ranging from a verbal warning to suspension or dismissal.`}
              </p>
              <h5 className="fw-bold py-3" style={{ fontSize: "19px" }}>
                {lang === "th"
                  ? `นโยบายฉบับนี้มีผลบังคับใช้ตั้งแต่วันที่ 22 กุมภาพันธ์ 2566
                โดยการอนุมัติของคณะกรรมการบริษัทในการประชุม ครั้งที่ 1/256`
                  : `The policy was approved at the Board of Directors’ Meeting, no.
                1/2013, and notification was given to the employees on July 18,
                2013.`}
              </h5>
              <ViewPDF
                title={
                  lang === "th"
                    ? "นโยบายและแนวทางปฏิบัติในการต่อต้านการทุจริตคอร์รัปชัน "
                    : "Policy and guidelines for combating corporate corruption"
                }
                href={
                  baseUrl +
                  GetDatas?.data[9].attributes.file.data.attributes.url
                }
              />
            </section> */}

            {/*------- นโยบายและแผนการบริหารความเสี่ยง ------*/}
            {/* <section id="risk" className="pt-5">
              <h1 className="fw-bold">
                {lang === "th"
                  ? `นโยบายและแผนการบริหารความเสี่ยง`
                  : `Risk Management Policy and Plan`}
              </h1>
              <h4 className="fw-bold">
                {lang === "th"
                  ? `นโยบายและแผนการบริหารความเสี่ยง`
                  : `Risk Management Policy and Plan`}
              </h4>
              <p style={{ textIndent: "30px" }}>
                {" "}
                {lang === "th"
                  ? ` บริษัทฯ ตระหนักและเห็นความสำคัญของการบริหารและจัดการองค์กรที่ดี เพื่อขับเคลื่อนองค์กรให้เติบโตและขยายธุรกิจอย่างมีเสถียรภาพ มีฐานะการเงินที่มั่นคงและสร้างผลตอบแทนแก่ผู้ถือหุ้นอย่างเหมาะสม คณะกรรมการบริษัทได้แต่งตั้งคณะกรรมการบริหารความเสี่ยง ประกอบด้วย คณะกรรมการตรวจสอบซึ่งเป็นคณะกรรมการอิสระ และ ผู้บริหาร  โดยได้จัดทำนโยบายบริหารความเสี่ยง หน้าที่และความรับผิดชอบ สำหรับบริหารจัดการความเสี่ยง จัดการเพื่อป้องกัน ลดความเสี่ยง หรือผลกระทบที่อาจเกิดขึ้นได้อย่างมีประสิทธิภาพ นอกจากนี้บริษัทฯ ได้ให้ความสำคัญกับการป้องกันการทุจริตคอร์รัปชัน บริษัทฯ มีการกำหนดนโยบายการปฏิบัติตามกฎหมายต่อต้านการทุจริตคอร์รัปชัน และการประเมินความเสี่ยงด้านการทุจริตคอร์รัปชัน ต่อเนื่องทุกปี โดยได้กำหนดนโยบายการป้องกันการมีส่วนเกี่ยวข้องกับการคอร์รัปชัน และบรรจุไว้ใน นโยบายการกำกับดูแลกิจการ และ คู่มือจริยธรรมทางธุรกิจของบริษัท ภายใต้หัวข้อเรื่อง  “นโยบายเกี่ยวกับการรับ  การให้ของขวัญและสิ่งตอบแทน”  “นโยบายเกี่ยวกับการป้องกันการทุจริตและการให้สินบน”  “นโยบายเกี่ยวกับการเลี้ยงรับรอง” และ “นโยบายเกี่ยวกับการบริจาคเพื่อการกุศลและการให้เงินสนับสนุนแก่หน่วยงานภายนอก” ทั้งนี้ บริษัทฯ อยู่ระหว่างจัดเตรียมความพร้อมในการเข้าร่วมประกาศเจตนารมณ์เข้าเป็นสมาชิกแนวร่วมต่อต้านคอร์รัปชันของภาคเอกชนไทย (Thai Private Sector Collective Action Against Corruption : CAC) โดยการทบทวนนโยบายและแนวทางปฏิบัติในการต่อต้านการทุจริตคอร์รัปชัน และการประเมินความเสี่ยงที่เกี่ยวกับการทุจริตภายในบริษัท`: `The Company realizes the importance of good management and organizational management. To drive the organization to grow and expand the business with stability. Have a stable financial position and create appropriate returns to the shareholders. The Board of Directors has appointed the Risk Management Committee, consisting of an Audit Committee, an independent committee and an executive. The Company has established a policy to comply with anti-corruption laws by setting the anti-corruption guidelines in the Company's Code of Business Ethics under the heading " "Policy on Receiving, Giving Gift and Return" "Policy on anti-corruption and bribery". “Entertainment Policy” and “Policy on Donations for Charitable Causes and Financial Contributions to External Organizations” The Company is currently preparing to join the Thai Private Sector Collective Action Against Corruption: CAC by reviewing its policies and practices to combat corporate corruption and assessing the risks associated with internal corruption`}
              </p>
              <h4 className="fw-bold">
                {lang === "th"
                  ? `ปัจจัยความเสี่ยงต่อการดำเนินธุรกิจของบริษัท`
                  : `Risk Factors for the Company’s Business Operation`}
              </h4>
              <p className="mb-1">
                {lang === "th"
                  ? `ปัจจัยความเสี่ยงต่อการดำเนินธุรกิจของบริษัท`
                  : `Risk Factors for the Company’s Business Operation`}
              </p>
              <ul className="mb-1">
                <li>
                  {" "}
                  {lang === "th"
                    ? `ความเสี่ยงจากความผันผวนของอัตราแลกเปลี่ยน
`
                    : `Risk from Exchange Rate Fluctuations`}
                </li>
                <li>
                  {" "}
                  {lang === "th"
                    ? `ความเสี่ยงจากการพึ่งพิงบุคลากร`
                    : `Risks from Personnel Dependency
`}
                </li>
                <li>
                  {" "}
                  {lang === "th"
                    ? `ความเสี่ยงจากการพึ่งพิงลูกค้ารายใหญ่
`
                    : `Risks from Major Dependency
`}
                </li>
                <li>
                  {" "}
                  {lang === "th"
                    ? `ความเสี่ยงจากการเปลี่ยนแปลงกฎระเบียบในการประกอบธุรกิจ`
                    : `Risk of Changes in Business Regulations`}
                </li>
                <li>
                  {" "}
                  {lang === "th"
                    ? `ความเสี่ยงจากลงทุนในต่างประเทศ
`
                    : `Risk from Investment Aboard
`}
                </li>
                <li>
                  {" "}
                  {lang === "th"
                    ? `ความเสี่ยงจากการมีผู้ถือหุ้นรายใหญ่ที่มีอิทธิพลต่อการกาหนดนโยบายการบริหารงาน
`
                    : `Risk from Major Shareholders’ Influence on Administration Policies`}
                </li>
                <li>
                  {" "}
                  {lang === "th"
                    ? `ความเสี่ยงด้านสภาพคล่อง
`
                    : `Liquidity Risk
`}
                </li>
                <li>
                  {" "}
                  {lang === "th"
                    ? `ความเสี่ยงจากการเปลี่ยนแปลงนโยบายภาครัฐ กฎหมาย ข้อบังคับ และกฎระเบียบต่าง ๆ
`
                    : `The Risk from Changes in Government Policies, Laws, Regulations, and Rules`}
                </li>
              </ul>
              <span className="text-black" style={{ fontSize: "16px" }}>
                {" "}
                {lang === "th"
                  ? `ความเสี่ยงต่อการลงทุนของผู้ถือหลักทรัพย์`
                  : `Investment Risk of Securities Holder
`}
              </span>
              <p>
                {" "}
                {lang === "th"
                  ? `ความเสี่ยงต่อการลงทุนในหลักทรัพย์ต่างประเทศ (กรณีผู้ออกหลักทรัพย์เป็นบริษัทต่างประเทศ)
`
                  : `Investment Risk of Foreign Securities (In case the issuer is a foreign Company)
`}
              </p>

              <ViewPDF
                title={lang === "th" ? `ปัจจัยความเสี่ยง` : `Risk factors`}
                href={
                  baseUrl +
                  GetDatas?.data[10].attributes.file.data.attributes.url
                }
              />
            </section> */}

            {/*------- กฎบัตรกรรมการ ------*/}

            <section id="charter" className="pt-5">
              <h1 className="fw-bold mb-4">
                {" "}
                {lang === "th" ? ` กฎบัตรกรรมการ` : `Board Charter`}
              </h1>
              {/* <ViewPDF
                title={
                  lang === "th"
                    ? `กฎบัตรคณะกรรมการบริษัท `
                    : `Charter of the Board of Directors bs วันพฤหัสบดีที่ 06/06/2024`
                }
                href={
                  baseUrl +
                  GetDatas?.data[11].attributes.file.data.attributes.url
                }
              />
              <ViewPDF
                title={
                  lang === "th"
                    ? ` กฎบัตรคณะกรรมการตรวจสอบ`
                    : `Charter of the Audit Committee
`
                }
                href={
                  baseUrl +
                  GetDatas?.data[12].attributes.file.data.attributes.url
                }
              />
              <ViewPDF
                title={
                  lang === "th"
                    ? ` กฎบัตรคณะกรรมการบริหารความเสี่ยง`
                    : `Charter of Risk Management Committee`
                }
                href={
                  baseUrl +
                  GetDatas?.data[13].attributes.file.data.attributes.url
                }
              />
              <ViewPDF
                title={
                  lang === "th"
                    ? ` กฎบัตรคณะกรรมการสรรหาและกำหนดค่าตอบแทน`
                    : `Charter of Nomination and Remuneration Committee
`
                }
                href={
                  baseUrl +
                  GetDatas?.data[14].attributes.file.data.attributes.url
                }
              />
              <ViewPDF
                title={
                  lang === "th"
                    ? `กฎบัตรคณะกรรมการกำกับดูแลกิจการ `
                    : `Charter of the Corporate Governance Committee
`
                }
                href={
                  baseUrl +
                  GetDatas?.data[15].attributes.file.data.attributes.url
                }
              />
              <ViewPDF
                title={
                  lang === "th"
                    ? `กฎบัตรคณะกรรมการบริหาร  `
                    : `Charter of the Executive Committee
`
                }
                href={
                  baseUrl +
                  GetDatas?.data[16].attributes.file.data.attributes.url
                }
              /> */}

              {GetDatas?.data
                ?.filter((item) => item.attributes?.type === "Board Charter")
                ?.sort((a, b) => a.attributes.number - b.attributes.number)
                ?.map((item) => (
                  <ViewPDF
                    title={item.attributes.file_name}
                    href={baseUrl + item.attributes.file.data.attributes.url}
                  />
                ))}

              {/* {lang === "th" ? ` ` : ``} */}
            </section>

            {/*------- ช่องทางร้องเรียน ------*/}
            <section id="complaints" className="py-5">
              <h1 className="fw-bold">
                {lang === "th" ? `ช่องทางร้องเรียน` : `Channel for complaints`}
              </h1>
              <h4 className="fw-bold">
                {lang === "th" ? `ส่งจดหมายลงทะเบียน` : `Register letter`}
              </h4>
              <div>
                {lang === "th" ? (
                  <p className="ps-5">
                    <>ส่งถึงคณะกรรมการบริษัท</>
                    <br />
                    <>
                      บริษัท เอ็นซีแอล อินเตอร์เนชั่นแนล โลจิสติกส์ จำกัด
                      (มหาชน) และบริษัทย่อย
                    </>
                    <br />
                    56/9-10 ซอยสมเด็จพระเจ้าตากสิน 12/1 ถนนสมเด็จพระเจ้าตากสิน
                    แขวงบุคคโล เขตธนบุรี กรุงเทพฯ 10600
                  </p>
                ) : (
                  <p className="ps-5">
                    <>The Board of Directors</>
                    <br />
                    <>NCL INTERNATIONAL LOGISTICS PUBLIC COMPANY LIMITED</>
                    <br />
                    <>
                      56/9-10 SoiTaksin 12/1, Taksin Road, Bukkalo, Thonburi,
                      Bangkok 10600
                    </>
                    <br />
                  </p>
                )}
              </div>

              <p>
                {lang === "th"
                  ? `เลขานุการบริษัทเป็นผู้รับผิดชอบในการรับเอกสารที่ส่งถึงคณะกรรมการบริษัทและดำเนินการส่งให้คณะกรรมการชุดย่อยหรือกรรมการที่เกี่ยวข้องและจะสรุปข้อเสนอแนะและประเด็นต่าง ๆ ทั้งหมดเพื่อจะเสนอคณะกรรมการบริษัททราบเป็นรายไตรมาส ยกเว้นเป็นเอกสารที่ส่งถึงคณะกรรมการตรวจสอบซึ่งจะถูกจัดส่งไปยังคณะกรรมการตรวจสอบโดยตรง`
                  : `The Company secretary is responsible for accepting documents sent to the Board of Directors and submitting them to sub-committees or related directors and summarizing all recommendations and issues for submission to the Board of Directors on a basis of quarterly except documents sent to the audit committee, which will be sent directly to the audit committee.`}
              </p>
              <h4 className="fw-bold">
                {lang === "th"
                  ? `ช่องทางการติดต่อกับบริษัท`
                  : `Channel for contact to the company`}
              </h4>
              <div style={{ overflowX: "auto" }} className="py-2">
                <table className="w-100 Channel-table ">
                  <thead>
                    <tr className="bg-blue text-center">
                      <th className="text-white sticky-col bg-blue"> </th>
                      <th className="text-white">Email</th>
                      <th className="text-white">
                        {lang === "th" ? `โทรศัพท์` : `Telephone`}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="sticky-col bg-white">
                        {lang === "th"
                          ? `คณะกรรมการบริษัท`
                          : `The Board of Directors`}
                      </td>
                      <td>
                        <a href="mailto:management@nclthailand.com">
                          management@nclthailand.com
                        </a>
                      </td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td className="sticky-col bg-white">
                        {lang === "th" ? `เลขานุการ` : `Corporate Secretary`}
                      </td>
                      <td>
                        <a href="mailto:Ratirat.c@nclthailand.com">
                          Ratirat.c@nclthailand.com
                        </a>
                      </td>
                      <td>
                        <a href="tel:024594945,,1202">02-4594945</a> # 1202
                      </td>
                    </tr>
                    <tr>
                      <td className="sticky-col bg-white">
                        {lang === "th"
                          ? `นักลงทุนสัมพันธ์`
                          : `Investor Relation`}
                      </td>
                      <td>
                        <a href="mailto:IR@nclthailand.com">
                          IR@nclthailand.com
                        </a>
                      </td>
                      <td>
                        <a href="tel:024594945,,509">02-4594945</a> # 509
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>

          <div className="col-xl-1  "></div>
          {/*------------ nav bar ------------*/}
          {/* <ul className="sticky"> */}
          <ul className="col-xl-4 sticky sticky_res  pb-4  border d-flex flex-column align-items-start gap-1">
            <li className="pointer" onClick={() => scrollToElement("criteria")}>
              {lang === "th"
                ? `นิยามกรรมการอิสระ`
                : `Criteria for Independent Directors`}
            </li>
            <li className="pointer" onClick={() => scrollToElement("article")}>
              {lang === "th" ? `ข้อบังคับบริษัท` : `Article of Association`}
            </li>
            <li className="pointer" onClick={() => scrollToElement("policy")}>
              {lang === "th"
                ? `นโยบายการกำกับดูแลกิจการ`
                : `Corporate Governance Policy`}
            </li>

            <li
              className=" subPointer text-secondary"
              onClick={() => scrollToSubElement("report")}
            >
              {lang === "th"
                ? ` รายงานการถือครองหลักทรัพย์ของกรรมการและผู้บริหาร ของบริษัทฯ ปี
              2568 และ 2567`
                : `Report on Securities Holdings of Directors and Executives of the Company for the Fiscal Years 2025 and 2024`}
            </li>

            {/* <li
              onClick={() => scrollToElement("Report on Securities Holdings")}
              className="pointer"
            >
              {lang === "th"
                ? `นโยบายและแนวทางปฏิบัติในการต่อต้านการทุจริตคอร์รัปชัน`
                : `Guidelines for Prevention of Involvement in Corruption`}
            </li>
            <li
              className="subPointer text-secondary"
              onClick={() =>
                scrollToSubElement("Report on Securities Holdings")
              }
            >
              {lang === "th"
                ? `นโยบายและแนวทางปฏิบัติในการต่อต้านการทุจริตคอร์รัปชัน`
                : `Guidelines for Prevention of Involvement in Corruption`}
            </li> */}
            {/* <li
              className="subPointer text-secondary"
              onClick={() => scrollToSubElement("receiving")}
            >
              {lang === "th"
                ? `นโยบายเกี่ยวกับการรับ-การให้ของขวัญและสิ่งตอบแทน`
                : `Policy on Receiving and Giving Gifts and Recompenses`}
            </li> */}

            {/* <li
              className=" subPointer text-secondary"
              onClick={() => scrollToSubElement("prevention")}
            >
              {lang === "th"
                ? `นโยบายเกี่ยวกับการป้องกันการทุจริตและการให้สินบน`
                : `Policy on Prevention of Corruption and Bribery`}
            </li> */}
            {/* <li
              className=" subPointer text-secondary"
              onClick={() => scrollToSubElement("hosting")}
            >
              {lang === "th"
                ? `นโยบายเกี่ยวกับการเลี้ยงรับรอง`
                : `Policy on Hosting and Entertainment`}
            </li>
            <li
              className=" subPointer text-secondary"
              onClick={() => scrollToSubElement("charitable")}
            >
              {lang === "th"
                ? `นโยบายเกี่ยวกับการบริจาคเพื่อการกุศลและการให้เงินสนับสนุนแก่หน่วยงานภายนอก`
                : `Policy on Charitable Donations and Funding to External Entities`}
            </li>
            <li
              className=" subPointer text-secondary"
              onClick={() => scrollToSubElement("penalty")}
            >
              {lang === "th" ? `บทลงโทษ` : `Penalty`}
            </li> */}
            {/* <li
              className="pointer"
              onClick={() => scrollToElement("Report on Securities Holdings")}
            >
              {lang === "th"
                ? `ปัจจัยความเสี่ยงต่อการดำเนินธุรกิจของบริษัท`
                : `Risk Factors`}
            </li> */}
            <li className="pointer" onClick={() => scrollToElement("charter")}>
              {lang === "th" ? `กฎบัตรกรรมการ` : `Board Charter`}
            </li>
            <li
              className="pointer"
              onClick={() => scrollToElement("complaints")}
            >
              {lang === "th" ? `ช่องทางร้องเรียน` : `Channel for complaints`}
            </li>
          </ul>
        </div>
      </div>

      {/* <ListNews /> */}

      <Footer />
    </Fragment>
  );
}

export default Governance;
